import { defineComponent as _defineComponent } from 'vue'
import { withDefaults, computed } from 'vue';
    import HintTooltip from '@ve/components/hintTooltip/desktop/HintTooltip.vue';
    import { Typo } from '@travelata-libs/ui-kit';
    import getConfirmationTypeName from '../lib/getConfirmationTypeName';
    import ConfirmationTypeIcon from './ConfirmationTypeIcon.vue';
    import { ConfirmationType } from '../lib/types';
    import ConfirmationTypeAdditionals from './ConfirmationTypeAdditionals.vue';

    interface ConfirmationTypeTooltip {
        type?: ConfirmationType;
    }

    
export default /*#__PURE__*/_defineComponent({
  __name: 'ConfirmationTypeTooltip',
  props: {
    type: { default: undefined }
  },
  setup(__props: any) {

const props = __props as { type: ConfirmationType }

    

    const headerText = computed(() => getConfirmationTypeName(props.type));


return { __sfc: true,props, headerText, HintTooltip, Typo, ConfirmationTypeIcon, ConfirmationTypeAdditionals }
}

})